export const LAYOUT_WIDTH = {
  MAX: '200px',
  MIN: '60px',
};
